import { FunctionComponent } from "react";
import SkeletonItem from "@Components/atoms/skeleton/SkeletonItem";
import { useBreakpoint } from "@Hooks/useBreakpoint";
import "./style.scss";

const primary96Color = "#ebf3ff";

const CheckoutPickupLocationsSkeleton: FunctionComponent = () => {
  const { isMediumScreen, isXSmallScreen } = useBreakpoint();
  const height = isMediumScreen ? 16 : 20;

  const item = (
    <div className="CheckoutPickupLocationsSkeleton-item">
      <div className="CheckoutPickupLocationsSkeleton-item-content">
        <SkeletonItem height={height} type="image" width={isXSmallScreen ? 130 : 192} />
        <SkeletonItem height={height} type="image" width={isXSmallScreen ? 182 : 308} />
        <SkeletonItem height={height} type="text" width={84} />
      </div>
      <SkeletonItem color={primary96Color} height={32} type="button" width={62} />
    </div>
  );

  return (
    <div className="CheckoutPickupLocationsSkeleton">
      {item}
      {item}
    </div>
  );
};

export default CheckoutPickupLocationsSkeleton;
